import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OauthRouteModule } from './oauth-route.module';
import { OauthComponent } from './oauth.component';
import { FormsModule } from '@angular/forms';
import { UserBlockComponent } from '@app/CustomControls/user-block/user-block.component';
// import { QdsLoader } from "@quartzds/core-angular";


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    OauthRouteModule,
    // QdsLoader
],
  declarations: [OauthComponent, UserBlockComponent]
})
export class OauthModule { }
